import { render } from "./NoticeHeader.vue?vue&type=template&id=0196592a&scoped=true"
import script from "./NoticeHeader.vue?vue&type=script&lang=js"
export * from "./NoticeHeader.vue?vue&type=script&lang=js"

import "./NoticeHeader.vue?vue&type=style&index=0&id=0196592a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0196592a"]])

export default __exports__